(function IIFE() {
    'use strict';

    /////////////////////////////

    function SocialActivityHistoryFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/social/activity/:methodKey', {}, {
            list: {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'history',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('SocialActivityHistoryFactory', SocialActivityHistoryFactory);
})();
